import { Injectable } from "@angular/core";

type Tracker = {
    send: (
      hitType: string,
      category: string,
      action: string,
      label?: string
    ) => void;
  };
  
  declare var gtag: Function;
  
  const has = Object.prototype.hasOwnProperty;
  
  @Injectable({ providedIn: "root" })
  export class GoogleAnalyticsService {
  
    logPageView(analyticsId, url) {
        gtag('event', 'page_view', {
            page_path: url
         })
    }
  }